import { getSVG } from './components/icons-loader.js';
import { showMoreFaqs, accordion } from './components/accordion.js';
import { slickSliderGenerator} from './components/sliders.js';

document.addEventListener("DOMContentLoaded", function () {
  accordion('.faqs-cards');
  slickSliderGenerator('testimonials', '.testimonials-container')
  showMoreFaqs();
  getSVG();
});
